document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll("[data-split]");

  elements.forEach(el => {
    const lines = el.textContent.trim().split(/\n|\r|\./g);
    el.innerHTML = '';

    lines.forEach((line, i) => {
      const span = document.createElement('span');
      span.textContent = line.trim();
      span.style.animationDelay = `${i * 0.3}s`;
      el.appendChild(span);
    });

    // Trigger animation once in view
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        el.classList.add("visible");
        observer.disconnect();
      }
    }, { threshold: 0.5 });

    observer.observe(el);
  });
});